<div class="container">
    @if (showLatestSearchTerms && latestSearchTerms()) {
        <div class="half">
            <sew-headline level="4" class="search-helper-headline">
                {{ 'SEARCH.HELP.LAST_SEARCHTERMS' | translate }}
            </sew-headline>
            @if (latestSearchTerms()!.length > 0) {
                @for (
                    searchTerm of loadMoreLatestSearchTerms
                        ? latestSearchTerms()!.slice(0, 10)
                        : latestSearchTerms()!.slice(0, 5);
                    track searchTerm
                ) {
                    <sew-link
                        icon="search"
                        class="search-term"
                        (click)="onLatestSearchResultSelected(searchTerm)"
                    >
                        <a type="button">{{ searchTerm }}</a>
                    </sew-link>
                }
                @if (showToggleLoadMoreButton()) {
                    <sew-link
                        [attr.icon]="loadMoreLatestSearchTerms ? 'arrow-chevron-up' : 'arrow-chevron-down'"
                        class="load-more"
                        (click)="toggleLoadMoreSearchTerms()"
                    >
                        <a type="button">
                            {{
                                (loadMoreLatestSearchTerms ? 'SEARCH.HELP.LESS' : 'SEARCH.HELP.LOAD_MORE')
                                    | translate
                            }}
                        </a>
                    </sew-link>
                }
            }
        </div>
    }
    @if (showSearchCriteria && criteriaExplanation) {
        <div class="half">
            <sew-headline level="4" class="search-helper-headline">
                {{ 'SEARCH.HELP.SEARCH_CRITERIA' | translate }}
            </sew-headline>
            @for (criteria of criteriaExplanation; track criteria) {
                <div class="search-criteria">
                    @if (criteria.content.length) {
                        <sew-tooltip direction="bottom" [attr.auto-width]="isMobile ? null : true">
                            @for (content of criteria.content; track content) {
                                @if (content.type === 'text') {
                                    <sew-markdown
                                        [markdown]="content.text | replaceDoubleLinebreak"
                                    ></sew-markdown>
                                }
                                @if (content.type === 'image') {
                                    <img
                                        class="search-criteria-image"
                                        src="{{ content.src }}"
                                        title="{{ content.title }}"
                                        alt="{{ content.alt }}"
                                    />
                                }
                            }
                        </sew-tooltip>
                    }
                    <sew-ws-richtext>
                        <p>{{ criteria.headline }}</p>
                    </sew-ws-richtext>
                </div>
            }
        </div>
    }
</div>
<sew-button class="close" icon="close" hierarchy="tertiary" size="xs" show-icon-only>
    <button title="close" class="button-slot" (click)="closeClicked.emit(false)"></button>
</sew-button>
